import moment from "moment";
import "moment-timezone";

let diffInMilliSeconds;
export const timeDiffCalc = (dateNow, dateFrom) => {
  if (isNaN(dateFrom.getTime())) {
    return "";
  } else {
    diffInMilliSeconds = Math.abs(dateNow - dateFrom) / 1000;
  }
  // calculate days
  const days = Math.floor(diffInMilliSeconds / 86400);
  diffInMilliSeconds -= days * 86400;

  // calculate hours
  const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
  diffInMilliSeconds -= hours * 3600;

  // calculate minutes
  const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
  diffInMilliSeconds -= minutes * 60;

  let difference = "";
  if (days > 0) {
    difference += days === 1 ? `${days}d ` : `${days}d `;
  }

  difference += hours === 0 || hours === 1 ? `${hours}h ` : `${hours}h `;

  difference += minutes === 0 || hours === 1 ? `${minutes}m` : `${minutes}m`;

  return difference;
};
let EuDateFormate = process.env.REACT_APP_UNITS_SYSTEM;
export const dateFormate = (date) => {
  return EuDateFormate === "metric"
    ? moment(date).format("HH:mm  DD/MM/YYYY")
    : moment(date).format("hh:mm A MM/DD/YYYY ");
};
export const dateFormateFleet = (date, timezone) => {
  if (date !== "" && date !== undefined) {
    return EuDateFormate === "metric"
      ? moment?.utc(date)?.tz(timezone)?.format("HH:mm  DD/MM/YYYY")
      : moment?.utc(date)?.tz(timezone)?.format("hh:mm A  MM/DD/YYYY");
  } else {
    return "";
  }
};
export const dateFormateTrip = (date, timezone) => {
  if (date !== "" && date !== undefined) {
    return moment?.utc(date)?.tz(timezone)?.format("YYYY-MM-DD");
  } else {
    return "";
  }
};
export const adddateFormateTrip = (date, timezone) => {
  if (date !== "" && date !== undefined) {
    const tz = timezone;
    let date1 = moment(date).tz(tz, true);
    let date2 = moment.utc(date1).format("YYYY-MM-DDTHH:mm");
    return date2;
  } else {
    return "";
  }
};
// const tz = "America/New_York"; // GMT-0500
// let date = moment(fsromdate + startTime).tz(tz, true).format('YYYY-MM-DDThh:mm');
export const dateFormateTripTime = (date, timezone) => {
  if (date !== "" && date !== undefined) {
    return moment?.utc(date)?.tz(timezone)?.format("HH:mm");
  } else {
    return "";
  }
};

export const dateFormateToMeridiem = (date) => {
  return EuDateFormate === "metric"
    ? moment(date).format("HH:mm ")
    : moment(date).format("hh:mm A");
};
export const ViewFormateOnly = (date) => {
  return moment(date).utc().format("YYYY-MM-DD");
};

export const dateFormateOnly = (date) => {
  return EuDateFormate === "metric"
    ? moment(date).format("dd-MM-YYYY ")
    : moment(date).format("MM-dd-YYYY ");
};
export const metricdateFormate = (date) => {
  return EuDateFormate === "metric"
    ? moment(date).format("HH:mm  DD/MM/YYYY ")
    : moment(date).format("hh:mm A MM/DD/YYYY ");
};
